import { Experiment, Variant } from '@svt/abtest/lib/redux';
import React, { createContext } from 'react';
import { PlayContainerBase } from '../../ui-components/PlayContainer/PlayContainer.styles';
import CookieMessage from '../ApplicationHandler/CookieMessage';
import SkipLinks from '../SkipLinks/SkipLinks';
import Menu from './components/Menu/Menu';
import { GlobalHeader, StyledHeader, StyledHeaderElement } from './Header.styles';

export const HeaderContext = createContext({});

const Header = () => (
    <StyledHeaderElement>
        <CookieMessage />
        <SkipLinks />
        <Experiment projectId="svtplay" slug="header-test-3" defaultVariant="original">
            <Variant slug="original">
                <StyledHeader isVisible>
                    <PlayContainerBase>
                        <GlobalHeader className="lp_head">
                            <Menu />
                        </GlobalHeader>
                    </PlayContainerBase>
                </StyledHeader>
            </Variant>
            <Variant slug="top-categories">
                <StyledHeader isVisible>
                    <PlayContainerBase>
                        <GlobalHeader className="lp_head">
                            <Menu />
                        </GlobalHeader>
                    </PlayContainerBase>
                </StyledHeader>
            </Variant>
            <Variant slug="all-categories-editorial">
                <StyledHeader isVisible>
                    <PlayContainerBase>
                        <GlobalHeader className="lp_head">
                            <Menu />
                        </GlobalHeader>
                    </PlayContainerBase>
                </StyledHeader>
            </Variant>
            <Variant slug="all-categories-alphabetic">
                <StyledHeader isVisible>
                    <PlayContainerBase>
                        <GlobalHeader className="lp_head">
                            <Menu />
                        </GlobalHeader>
                    </PlayContainerBase>
                </StyledHeader>
            </Variant>
            <Variant slug="top-categories-and-sticky">
                <StyledHeader isSticky isVisible>
                    <PlayContainerBase>
                        <GlobalHeader isThin className="lp_head">
                            <Menu />
                        </GlobalHeader>
                    </PlayContainerBase>
                </StyledHeader>
            </Variant>
        </Experiment>
    </StyledHeaderElement>
);

export default Header;
